const initialState = {
    activeMenuLabel: "",
  };
  
  export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_ACTIVE_MENU_LABEL":
        return { ...state, activeMenuLabel: action.payload };
      default:
        return state;
    }
  };
  
  export const setActiveMenuLabel = (label) => ({
    type: "SET_ACTIVE_MENU_LABEL",
    payload: label,
  });
  